import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 120000, // Increased to 120 seconds
});

export const analyzePatient = async (patientData) => {
  try {
    console.log('Sending request to /analyze-patient with data:', patientData);
    const response = await api.post('/analyze-patient', {
      patient: patientData
    }, {
      timeout: 120000 // Increased to 120 seconds
    });
    return response.data;
  } catch (error) {
    // ✅ DEBUG: Log the validation errors
    console.error('=== BACKEND REQUEST ERROR ===');
    console.error('URL:', error.config?.url);
    console.error('Status:', error.response?.status);
    console.error('Detail:', JSON.stringify(error.response?.data?.detail, null, 2));
    console.error('Full Error:', error);
    console.error('================================');
    throw error;
  }
};


// API Methods
/*export const analyzePatient = async (patientData) => {
  try {
    const response = await api.post('/analyze-patient', { patient: patientData });
    return response.data;
  } catch (error) {
    console.error('Error analyzing patient:', error);
    throw error;
  }
};
*/

export const getTaperPlan = async (taperRequest) => {
  try {
    const response = await api.post('/get-taper-plan', taperRequest);
    return response.data;
  } catch (error) {
    console.error('Error getting taper plan:', error);
    throw error;
  }
};

export const checkInteractions = async (interactionRequest) => {
  try {
    const response = await api.post('/interaction-checker', interactionRequest);
    return response.data;
  } catch (error) {
    console.error('Error checking herb-drug interactions:', error);
    throw error;
  }
};

export const checkDrugInteractions = async (drugInteractionRequest) => {
  try {
    const response = await api.post('/check-interactions', drugInteractionRequest);
    return response.data;
  } catch (error) {
    console.error('Error checking drug-drug interactions:', error);
    throw error;
  }
};

export const getHealthCheck = async () => {
  try {
    const response = await api.get('/health');
    return response.data;
  } catch (error) {
    console.error('Error checking health:', error);
    throw error;
  }
};

export const warmupBackend = async () => {
  const response = await api.get('/health', { timeout: 180000 });
  return response.data;
};

export const extractMedicationsFromFile = async ({ file, uploadType = 'prescription' }) => {
  const endpoint =
    uploadType === 'prescription' ? '/extract-from-prescription' : '/extract-brown-bag';

  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post(endpoint, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 180000,
  });

  return response.data;
};

export const getSupportedDrugs = async () => {
  try {
    const response = await api.get('/supported-drugs');
    return response.data;
  } catch (error) {
    console.error('Error getting supported drugs:', error);
    throw error;
  }
};

export default api;
